import { render, staticRenderFns } from "./AudioList.vue?vue&type=template&id=a0d31be4&scoped=true"
import script from "./AudioList.vue?vue&type=script&lang=ts"
export * from "./AudioList.vue?vue&type=script&lang=ts"
import style0 from "./AudioList.vue?vue&type=style&index=0&id=a0d31be4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d31be4",
  null
  
)

export default component.exports